import { FunctionComponent } from 'react';
import { IconButton, Tooltip } from '@mui/material';

//icon
import { CaretCircleLeft } from '@phosphor-icons/react';

const GoBackButton: FunctionComponent<{}> = () => {
    return (
        <Tooltip title="Back" placement="top">
            <IconButton size="small" onClick={() => window.history.back()}>
                <CaretCircleLeft size={34} color="#4D4D4D" />
            </IconButton>
        </Tooltip>
    );
};

export default GoBackButton;
